// src/api/vendorApi.js
import apiClient from './axios';

const vendorApi = {
  // GET all (with pagination + search)
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/vendor/', {
      params: { page, page_size: pageSize, search },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },

  // GET lightweight dropdown (id/name/code, active only, unpaginated by design —
  // the server already scopes this to a small projection, no page_size hack needed)
  getDropdown: async () => {
    const response = await apiClient.get('/vendor/dropdown/');
    return response.data;
  },

  // GET by ID
  getById: async (id) => {
    const response = await apiClient.get(`/vendor/${id}/`);
    return response.data;
  },

  // CREATE
  create: async (data) => {
    const response = await apiClient.post('/vendor/', data);
    return response.data;
  },

  // UPDATE (PATCH)
  update: async (id, data) => {
    const response = await apiClient.patch(`/vendor/${id}/`, data);
    return response.data;
  },

  // DELETE
  delete: async (id) => {
    await apiClient.delete(`/vendor/${id}/`);
    return id;
  },

  /* -------------------------- EXPORT -------------------------- */
  exportCsv: async () => {
    const response = await apiClient.get('/vendor/export/', {
      responseType: 'blob',
    });
    return response.data; // Blob
  },

  /* -------------------------- IMPORT PREVIEW -------------------------- */
  importPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/vendor/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data; // { preview: [...], total: number }
  },

  /* -------------------------- IMPORT CONFIRM -------------------------- */
  importConfirm: async (preview) => {
    const response = await apiClient.post('/vendor/import-confirm/', { preview });
    return response.data;
  },
};

export default vendorApi;